import { MobileOnlyOptions } from "./MobileOnlyOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate10: LandingPageConfigOptions = {
  ...MobileOnlyOptions,
};
